import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Chart} from 'chart.js';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {MatDialog} from '@angular/material/dialog';
import {Observable, Subscription} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatSnackBar} from "@angular/material/snack-bar";

  @Component({
    selector: 'app-bar-chart-never-logged-pathology',
    templateUrl: './bar-chart-never-logged-pathology.component.html',
    styleUrls: ['./bar-chart-never-logged-pathology.component.css']
  })
    export class BarChartNeverLoggedPathologyComponent implements OnInit, OnDestroy {
      // per inizializzazione
      getAuthState: Observable<any>;
      getDoctorState: Observable<any>;
      isAuthenticated: boolean;
      user = null;
      errorMessage = null;
      subscription1: Subscription;
      subscription2: Subscription;
      subscription3: Subscription;
      subscription4: Subscription;
      subscription5: Subscription;
      title = "Patologia";
      destination = 'never-logged';
      // elementi che servono per il bar-chart
      canvas: any;
      ctx: any;
      myChartNeverLoggedPatients: Chart;

      // ******************************************************************************************************************
      // seguenti righe: inizializzazione dei pazienti 
      // ******************************************************************************************************************
      neverLoggedGlobalUC = 0;
      neverLoggedGlobalCD = 0;
      neverLoggedGlobalAltro = 0;

      loggedGlobalUC = 0;
      loggedGlobalCD = 0;
      loggedGlobalAltro = 0;

      UCGlobalPatients = 0;
      CDGlobalPatients = 0;
      AltroGlobalPatients = 0;

      neverLoggedGlobalPatientsArray = [];
      loggedGlobalPatientsArray = [];
      neverLoggedPatientsGlobal = [];
      // ******************************************************************************************************************
      // bar chart dei pazienti 
      // ******************************************************************************************************************
      public barChartLabelsGlobalNeverLogged = ['MALATTIA DI CROHN', 'COLITE ULCEROSA','ALTRO'];
      public barChartTypeGlobalNeverLogged = 'horizontalBar';
      public barChartLegendGlobalNeverLogged = true;
      public barChartDataGlobalNeverLogged = [
        {
          data: this.loggedGlobalPatientsArray, label: 'Accesso effettuato', backgroundColor: ['teal', 'teal','teal'],
          hoverBackgroundColor: ['#066', '#066','#066'],maxBarPercentage : 0.5,  // number (pixels) or 'flex'
        },
        {
          data: this.neverLoggedGlobalPatientsArray, label: 'Accesso non effettuato', backgroundColor: ['orangered', 'orangered','orangered'],
          hoverBackgroundColor: ['#cc3700', '#cc3700','cc3700'], maxBarPercentage: 0.5,  // number (pixels) or 'flex'
        }];
      


      // constructor
      constructor(private store: Store<AppState>,
                  private doctorService: DoctorService,
                  private snackBar: MatSnackBar) {
        this.getAuthState = this.store.select(selectAuthState);
        this.getDoctorState = this.store.select(selectDoctorState);
      }
      // ******************************************************************************************************************
      // metodo all'inizio
      ngOnInit(): void {
        this.subscription5 = this.getAuthState.subscribe((state) => {
          this.isAuthenticated = state.isAuthenticated;
          this.user = JSON.parse(localStorage.getItem('user'));
          this.errorMessage = state.errorMessage;
          this.retrieveGlobalNeverLoggedCD();
        });
      }
      ngOnDestroy(): void {
        this.subscription1.unsubscribe();
        this.subscription2.unsubscribe();
        this.subscription3.unsubscribe();
        this.subscription4.unsubscribe();
        this.subscription5.unsubscribe();
      }
      // ******************************************************************************************************************
      // metodi che si richiamano in cascata e prendono tutti gli inattivi in telemedicina
      // e in standard e poi tutti
      // i pazienti in ogni categoria per poter calcolare gli attivi
      // retrieve global active and inactive patients (le funzioni si richiamano in cascata) bar chart
      retrieveGlobalNeverLoggedCD() {
        this.subscription1 = this.doctorService.getNeverLoggedCDNumber().subscribe(npatients => {
          this.neverLoggedGlobalCD = parseInt(npatients.toString());
          this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobalCD); // riempio vettore del bar-chart con telemedicina
          this.retrieveGlobalNeverLoggedUC();
        }, error => {
          if (error.status === 500) {
            localStorage.setItem('expirationTime', '0');
            console.log('SESSIONE SCADUTA');
            location.reload();
          }
        });
      }
      retrieveGlobalNeverLoggedUC() {
        this.subscription2 = this.doctorService.getNeverLoggedUCNumber().subscribe(npatients => {
          this.neverLoggedGlobalUC = parseInt(npatients.toString());
          this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobalUC); // riempio il vettore del bar chart con standard
          this.retrieveGlobalNeverLoggedAltro();
        }, error => {
          if (error.status === 500) {
            localStorage.setItem('expirationTime', '0');
            console.log('SESSIONE SCADUTA');
            location.reload();
          }
        });
      }

      retrieveGlobalNeverLoggedAltro() {
        this.subscription3 = this.doctorService.getNeverLoggedAltroNumber().subscribe(npatients => {
          this.neverLoggedGlobalAltro = parseInt(npatients.toString());
          this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobalAltro); // riempio il vettore del bar chart con standard    
          this.retrieveGlobalUCCD();
        }, error => {
          if (error.status === 500) {
            localStorage.setItem('expirationTime', '0');
            console.log('SESSIONE SCADUTA');
            location.reload();
          }
        });
      }

    
      retrieveGlobalUCCD() {
        this.subscription4 = this.doctorService.getGlobalUCCDNumber().subscribe(num => {
          this.UCGlobalPatients = num[0];
          this.CDGlobalPatients = num[1];
          this.AltroGlobalPatients = num[2];
          this.loggedGlobalCD = this.CDGlobalPatients - this.neverLoggedGlobalCD;
          this.loggedGlobalPatientsArray.push(this.loggedGlobalCD); // riempio il vettore del bar chart con telemedicina
          this.loggedGlobalUC = this.UCGlobalPatients - this.neverLoggedGlobalUC;
          this.loggedGlobalPatientsArray.push(this.loggedGlobalUC); // riempio il vettore del bar chart con standard
          this.loggedGlobalAltro = this.AltroGlobalPatients - this.neverLoggedGlobalAltro;
          this.loggedGlobalPatientsArray.push(this.loggedGlobalAltro); // riempio il vettore del bar chart con telemedicina
         
          this.canvasSetting();
        }, error => {
          if (error.status === 500) {
            localStorage.setItem('expirationTime', '0');
            console.log('SESSIONE SCADUTA');
            location.reload();
          }
        });
      }
     
      canvasSetting() {
          this.canvas = document.getElementById('myChartNeverLoggedPathology') as HTMLCanvasElement;
          this.ctx = this.canvas.getContext('2d');
          this.myChartNeverLoggedPatients = new Chart(this.ctx, {
            type: this.barChartTypeGlobalNeverLogged,
            data: {
              labels: this.barChartLabelsGlobalNeverLogged,
              datasets: this.barChartDataGlobalNeverLogged,
            },
            options: {
              maintainAspectRatio: true,
              responsive: true,

              scales: {
                xAxes: [{
                  display: true,
                  stacked: false,
                  ticks: {
                    fontSize: 12,
                    fontStyle: 'bold',
                    fontFamily: 'Helvetica',
                    fontColor: '#006192'
                  }
                }],
                yAxes: [{
                  display: true,
                  stacked: false,
                  ticks: {
                    fontSize: 12,
                    fontStyle: 'bold',
                    fontFamily: 'Helvetica',
                    fontColor: '#006192'
                  }
                }],
              },
              legend: {
               
                display: true,
                position: 'top',
                labels: {
                  usePointStyle: true,
                  fontColor: '#006192',
                  fontSize: 18,
                  fontFamily: 'Helvetica',
                }
              },
              tooltips: {
                // content: '{pathology}: {number}',
                backgroundColor: '#1c1c1c',
                bodyFontSize: 18,
                titleFontSize: 18,
                cornerRadius: 5,
                caretPadding: 10
              },
              title: {
                display: true,
                text: "N° di utenti che hanno/non hanno effettuato l'accesso",
                fontColor: '#006192',
                fontSize: 20,
                fontFamily: 'Helvetica',
              },
              hover: {
                mode: 'nearest',
                intersect: true
              }
            }
          });
          } // dopo aver ottenuto tutti i dati creo il bar chart
      
    }
    